
    import { registerApplication, start } from 'single-spa';
  
    registerApplication(
      'platform',
      function() {
        return import('./packages/platform/platform.ts');
      },
      function(location) {
        return require('./packages/platform/activityFunction.ts').default(location);
      });

  
    registerApplication(
      'account',
      function() {
        return import('./packages/account/account.ts');
      },
      function(location) {
        return require('./packages/account/activityFunction.ts').default(location);
      });

  
    registerApplication(
      'akf',
      function() {
        return import('./packages/akf/akf.ts');
      },
      function(location) {
        return require('./packages/akf/activityFunction.ts').default(location);
      });

  
    registerApplication(
      'content',
      function() {
        return import('./packages/content/content.ts');
      },
      function(location) {
        return require('./packages/content/activityFunction.ts').default(location);
      });

  
    registerApplication(
      'material',
      function() {
        return import('./packages/material/material.ts');
      },
      function(location) {
        return require('./packages/material/activityFunction.ts').default(location);
      });

  
    registerApplication(
      'resource',
      function() {
        return import('./packages/resource/resource.ts');
      },
      function(location) {
        return require('./packages/resource/activityFunction.ts').default(location);
      });

  
    start();
  // // <reference path="./typings/index.d.ts" />
// // <reference path="@jswork/styled-box/dist/components/types" />
import StyledBox from '@jswork/styled-box';

declare let process: any;

declare global {
  const nx: any;
  const View: typeof StyledBox;
}
